import { useAppData } from '@app/providers/app-data-context'
import { CALLBACK_WAIT_MINUTES } from '@shared/config'
import { Box, Button, FlexBox, H1, Link, Typography } from '@vp/swan'
import { useEffect } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useFormData } from '../../context/form-data-context'
import { usePageFlow } from '../../context/page-flow-context'

export const Confirmation = () => {
  const { t } = useTranslation()
  const { channel, setFooterVisible } = usePageFlow()
  const { formData } = useFormData()
  const { helpCenterUrls } = useAppData()

  useEffect(() => {
    setFooterVisible(false)
    return () => setFooterVisible(true)
  }, [setFooterVisible])

  const helpCenterPath = helpCenterUrls?.path ?? '/customer-care/help-center'

  const transValues = formData.channel === 'callback' ? { phone: formData.phone, minutes: CALLBACK_WAIT_MINUTES } : { email: formData.email }

  return (
    <Box data-testid="step-confirmation">
      <H1 mb={6} fontSkin="title-headline">
        {t(`contact_us.page.steps.confirmation.${channel}.title`)}
      </H1>

      <Box mb={7} style={{ maxWidth: '434px' }}>
        <Typography>
          <Trans
            i18nKey={`contact_us.page.steps.confirmation.${channel}.description`}
            values={transValues}
            components={{ bold: <strong data-testid="confirmation-contact-value" /> }}
          />
        </Typography>
      </Box>

      <FlexBox flexDirection="row" gap="between-actions" flexWrap="wrap">
        <Box data-testid="confirmation-help-center-action">
          <Button
            skin="secondary"
            render={(props) => (
              <Link {...props} data-testid="confirmation-help-center-link" href={helpCenterPath}>
                {t(`contact_us.page.steps.confirmation.${channel}.actions.help_center`)}
              </Link>
            )}
          />
        </Box>
        <Box data-testid="confirmation-homepage-action">
          <Button
            skin="secondary"
            render={(props) => (
              <Link {...props} data-testid="confirmation-homepage-link" href="/">
                {t(`contact_us.page.steps.confirmation.${channel}.actions.homepage`)}
              </Link>
            )}
          />
        </Box>
      </FlexBox>
    </Box>
  )
}
